import { Center } from "@chakra-ui/react";
export default function UnauthorizedPage({ minH, title = "401 Unauthorized" }) {
  return (
    <Center minH={minH} fontWeight="bold" fontSize={58}>
      <h1>{title}</h1>
    </Center>
  );
}
